import { render, staticRenderFns } from "./ViewCollectedPromoVouchersAllDetails.vue?vue&type=template&id=4e72ce38&"
import script from "./ViewCollectedPromoVouchersAllDetails.vue?vue&type=script&lang=js&"
export * from "./ViewCollectedPromoVouchersAllDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports